import Constant from '@/common/constant/Constant';

export const prepareParamsGetListViewInProject = (
    affiliationProject,
    visibleRange,
    visibleType
) => {
    let params = {
        KeyConditionExpression: '#visibleRange = :visibleRange AND #sortKey = :sortKey',

        FilterExpression: '#affiliationProject = :affiliationProject_eq',

        ExpressionAttributeNames: {
            '#visibleRange': 'visibleRange',
            '#sortKey': 'visibleType',
            "#affiliationProject": "affiliationProject"
        },
        ExpressionAttributeValues: {
            ':visibleRange': {
                S: visibleRange
            },
            ':sortKey': {
                S: visibleType
            },
            ':affiliationProject_eq': {
                S: affiliationProject
            }
        },

        IndexName: Constant.GSI.VIEW_GSI_1
    };

    return params;
};

export const prepareParamsGetListViewByVisibleRange = (
    affiliationProject,
    visibleRange,
    visibleType,
    definitionView
) => {
    let params = {
        KeyConditionExpression: '#visibleRange = :visibleRange AND #sortKey = :sortKey',

        FilterExpression: '#affiliationProject = :affiliationProject_eq AND #definitionView = :definitionView_eq',

        ExpressionAttributeNames: {
            '#visibleRange': 'visibleRange',
            '#sortKey': 'visibleType',
            "#affiliationProject": "affiliationProject",
            "#definitionView": "definitionView"
        },
        ExpressionAttributeValues: {
            ':visibleRange': {
                S: visibleRange
            },
            ':sortKey': {
                S: visibleType
            },
            ':affiliationProject_eq': {
                S: affiliationProject
            },
            ':definitionView_eq': {
                S: definitionView
            }
        },

        IndexName: Constant.GSI.VIEW_GSI_1
    };

    return params;
};
